import { TableView as TiptapTableView } from '@tiptap/extension-table'
import { Node } from '@tiptap/pm/model'
import { EditorView } from '@tiptap/pm/view'
import { debounce } from 'lodash'

export class TableView extends TiptapTableView {
  cleanup: (() => void) | undefined
  tableResizeWrapper: HTMLElement

  constructor(
    node: Node,
    view: EditorView,
    cellMinWidth: number,
    resizeParentSelector: string
  ) {
    super(node, cellMinWidth)
    const resizeParent = view.dom.closest(resizeParentSelector)

    this.tableResizeWrapper = this.dom
    this.tableResizeWrapper.className = 'tableResizeWrapper'

    const tableWrapper = document.createElement('div')
    tableWrapper.className = 'tableWrapper'
    tableWrapper.appendChild(this.tableResizeWrapper)

    this.dom = tableWrapper

    if (resizeParent != null) {
      const debouncedCallback = debounce<ResizeObserverCallback>(
        () => this.updateTableWidth(resizeParent),
        250
      )
      const resizeObserver = new ResizeObserver(debouncedCallback)

      // Sets initial table width
      this.updateTableWidth(resizeParent)

      // Observes the parent element for resize
      // events to update the table width accordingly
      resizeObserver.observe(resizeParent)

      this.cleanup = () => {
        debouncedCallback.cancel()
        resizeObserver.disconnect()
      }
    }
  }

  private updateTableWidth(resizeParent: Element): void {
    this.tableResizeWrapper.style.maxWidth = `${resizeParent.clientWidth - 100}px`
  }

  destroy() {
    this.cleanup?.()
  }
}
